import { Hourglass } from 'lucide-react';

interface PhotoProcessingOverlayProps {
  label: string;
  rounded?: boolean;
}

/** Halbtransparentes Overlay mit Sanduhr-Symbol fuer ein Foto, das gerade von einer
 * Hintergrundaufgabe (z.B. ComfyUI-Freistellung) bearbeitet wird - siehe useDogPhotoTasks. */
export function PhotoProcessingOverlay({ label, rounded = true }: PhotoProcessingOverlayProps) {
  return (
    <div
      className={`absolute inset-0 flex items-center justify-center bg-dark-950/60 ${rounded ? 'rounded-[inherit]' : ''}`}
      title={label}
      aria-label={label}
      role="status"
    >
      <Hourglass size={22} className="animate-pulse text-dark-50" />
    </div>
  );
}
